<template>
    <div 
    class="tag-item" 
    :class="{active}"
    @click.stop="_itemClick"
    >
        <el-tooltip class="item" effect="light" :content="title" placement="top-end" :open-delay="1500">
            <span>{{title}}</span>
         </el-tooltip>

        <i 
            v-if="!noclose" 
            class="el-icon-close"
            :class="btnHover ? 'el-icon-error' : 'el-icon-close'"
            @mouseenter="_mouseEnterBtn"
            @mouseleave="_mouseLeaveBtn"
            @click.stop="_closeClick"
        ></i>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        noclose: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '新标签页',
        },
        click: {
            type: [Boolean, Function],
            default: false,
        },
    },
    data() {
        return {
            btnHover: false,
        };
    },
    methods: {
        // 鼠标移入删除按钮
        _mouseEnterBtn() {
            this.btnHover = true;
        },
        // 鼠标移出删除按钮
        _mouseLeaveBtn() {
            this.btnHover = false;
        },
        // 关闭按钮点击
        _closeClick() {
            this.$emit('close');
        },
        // tag点击
        _itemClick() {
            if (this.click) {
                this.click();
                return;
            }

            this.$emit('click');
        },
    }
};
</script>

<style lang="scss" scoped>
    $primaryColor: #AB6BBD;
    $textHeight: 14px;

    .tag-item{
        display: inline-block;
        line-height: $textHeight;
        padding: 8px;
        background: #F0F2F5;
        color: #333333;
        cursor: pointer;
        border-radius: 2px;
        transition: all .1s;
        font-size: 14px;
        vertical-align: middle;
       
        span{
            max-width: 200px;
            overflow:hidden;
            text-overflow:ellipsis;
            -o-text-overflow:ellipsis;
            white-space:nowrap;
            float: left;
        }

        &:hover{
            background: $primaryColor;
            color: white;
        }

        &.active{
            background: $primaryColor;
            color: white;
            font-size: $textHeight;
            font-weight: bold;
        }

        & + .tag-item{
            margin-left: 8px;
        }
    }
</style>